import React, {
	useState,
	useEffect,
	//useCallback,
} from 'react';
//import {
	//useSelector,
 	//useDispatch,
//} from 'react-redux';
import Modal from 'react-bootstrap/Modal';
//import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import DatePicker from 'react-datepicker';
//import Card from 'react-bootstrap/Card';
import addSeconds from 'date-fns/addSeconds';
//import { SessionDetailControls } from './sessionDetails.js';
//import { registerLocale, setDefaultLocale } from  "react-datepicker";
//import es from 'date-fns/locale/es';
//registerLocale('es', es)

/**
 *
 * This is a modal popup window which displays open sessions
 * and asks the user to close the session.
 *
 * The user can select a session close time
 *
 * This is called when
 * - a session close button is clicked
 * - a new session is started when there is a session open
 */

const SessionChangeModal = (props) => {
	const {
		//show,
		openSessions,
		haveOpenSessions,
		handleCloseOpenSessions,
		handleInitiateNewSessionData,
		sessionChangeModalShow,
		setSessionChangeModalShow,
		addingNewSession,
		setValues,
		//values,
	} = props
	const [sessionCloseTime, setSessionCloseTime] = useState(null);
	const [sessionOpenTime, setSessionOpenTime] = useState(null);
	const [sessionChangeTime, setSessionChangeTime] = useState(null);
	const [disableCloseSessions, setDisableCloseSessions] = useState(false);
	//const [disableBtnCloseThenOpen, setDisableBtnCloseThenOpen] = useState(false);
	//const [disableBtnOpenSession, setDisableBtnOpenSession] = useState(false);
	const [disableSessionCloseTime, setDisableSessionCloseTime] = useState(false);

	//console.log('sessionCloseTime',sessionCloseTime)
	//console.log('sessionOpenTime',sessionOpenTime)
	//console.log('disableSessionCloseTime', disableSessionCloseTime)

	// useEffect(() => {
	// 	if (sessionOpenTime < sessionCloseTime){
	// 		setSessionOpenTime(addSeconds(sessionCloseTime,5))
	// 		alert('Session opening time must be the same or after old session closing time')
	// 	}
	// },[sessionCloseTime, sessionOpenTime])

	useEffect(() => {
		//console.log('sessionChangeModalShow trigger')
		if (sessionChangeModalShow){
			const nowz = new Date();
			setSessionChangeTime(nowz);
			setSessionCloseTime(nowz);//may or may not be used if none to close
			if (haveOpenSessions){
				setSessionOpenTime(addSeconds(nowz,1));
				setValues(values => ({ ...{}, ...{sessionStartObj: addSeconds(nowz,1)} }));// add start time
			} else {//open new only
				setSessionOpenTime(nowz);
				setValues(values => ({ ...{}, ...{sessionStartObj: nowz} }));// add start time
			}

		}
	},[sessionChangeModalShow, haveOpenSessions, setValues])

	// useEffect(() => {
	// 	if (!haveOpenSessions || sessionCloseTime === null || sessionOpenTime === null){
	// 		//console.log('disableBtnCloseThenOpen')
	// 		setDisableBtnCloseThenOpen(true)
	// 	} else {
	// 		setDisableBtnCloseThenOpen(false)
	// 	}
	// },[sessionCloseTime, sessionOpenTime, haveOpenSessions])

	// useEffect(() => {
	// 	if (haveOpenSessions || sessionOpenTime === null){
	// 		setDisableBtnOpenSession(true)
	// 	} else {
	// 		setDisableBtnOpenSession(false)
	// 	}
	// },[sessionOpenTime, haveOpenSessions])

	useEffect(() => {
		if (!haveOpenSessions || sessionCloseTime === null){
			setDisableCloseSessions(true)
		} else {
			setDisableCloseSessions(false)
		}
	},[sessionCloseTime, haveOpenSessions])

	useEffect(() => {
		if (!haveOpenSessions){
			setDisableSessionCloseTime(true)
		} else {
			setDisableSessionCloseTime(false)
		}
	},[haveOpenSessions])

	//console.log('haveOpenSessions', haveOpenSessions)
	//console.log('sessionCloseTime', sessionCloseTime)
	//console.log('sessionOpenTime', sessionOpenTime)

	const handleSessionChangeTime = (timeObj) =>{
		console.log('handleSessionChangeTime()')
		setSessionChangeTime(timeObj);
		setSessionCloseTime(timeObj);
		setSessionOpenTime(addSeconds(timeObj,1));
		setValues(values => ({ ...{}, ...{sessionStartObj: addSeconds(timeObj,1)} }));// add start time
	}

	const handleBtnCloseSessions = () =>{
		const reloadAfter = true
		handleCloseOpenSessions(openSessions, sessionCloseTime, reloadAfter)
		setSessionChangeModalShow(false)	//close this modal window
		if (addingNewSession){
			//this modal was opened as the user selected a new session but an old one needed closing first
			//handleInitiateNewSessionData(new Date());
			//setSessionDetailShow(true);
			handleInitiateNewSessionData(sessionOpenTime)
		}

	}

	// const handleBtnCloseThenOpen = () =>{
	// 	handleCloseOpenSessions(openSessions, sessionCloseTime)
	// 	handleInitiateNewSession(sessionOpenTime)
	// 	setSessionChangeModalShow(false)	//close this modal window
	// }
	// const handleBtnOpenSession = () =>{
	// 	handleInitiateNewSession(sessionOpenTime)
	// 	setSessionChangeModalShow(false)	//close this modal window
	// }

	const closeTimezone = (openSessions[0] === undefined)? '':openSessions[0].timezone;
	//const sessionChangeTimeDesc = (haveOpenSessions)?'Session Change':'Session Start';

	return (
		<Template
			{ ...props }
			header = {'Close current session'}
			//title = { getTitle(props) }
			footer = {
				<>
				{/* <div>
					Note: Any new sessions will initially open in the default timezone. You can change this at any time in the next screen.
				</div> */}
					<Button
						id = 'btnCloseSessions'
						variant = "info"
						onClick = {() => handleBtnCloseSessions()}
						{ ...(disableCloseSessions && { disabled: true }) }
					>
						Accept
						{/* { addingNewSession ? 'Close open sessions': ''} */}
					</Button>
					{/* <Button
						id = 'btnCloseThenOpen'
						variant = "info"
						onClick = {() => handleBtnCloseThenOpen()}
						{ ...(disableBtnCloseThenOpen && { disabled: true }) }
					>
						Close open sessions, then Open new session
					</Button>
					<Button
						id = 'btnOpenSession'
						variant = "info"
						onClick = {() => handleBtnOpenSession()}
						{ ...(disableBtnOpenSession && { disabled: true }) }
					>
						Open new session
					</Button> */}
					<Button
						id = 'btnQuit'
						variant = "info"
						onClick = { () => setSessionChangeModalShow(false) }
					>
						Exit without changes
					</Button>
				</>
			}
		>
			<MainMessage
				addingNewSession = { addingNewSession }
				openSessions = { openSessions }
			/>

			{ !disableSessionCloseTime &&
			<Row style={{ height: '37.883px'}}>
				<Col sm='3'><p style = {{ paddingTop: '0.3em' }}>Session Close</p></Col>
				<Col sm='9'>
					<DatePicker
						id = 'sessionChangeTime'
						className = { 'datepickerxx form-control' }
						dateFormat = "dd MMM yyyy HH:mm"
						selected={ sessionChangeTime }
						showTimeSelect
						todayButton="Now"
						timeIntervals = { 10 }
						scrollableYearDropdown = {true}
						showYearDropdown = {true}
						onChange={ handleSessionChangeTime }
						style = {{width: '15em'}}
					/>
					<span style={{paddingLeft: '3em'}}>{ closeTimezone }</span>
				</Col>
			</Row>
			}
		</Template>
	)
}

const MainMessage = (props) =>{
	const postMsg = 'What time did you move the weigher? Please carefully set the time for the session close. All times are in the session time zone as indicated.'
	if (props.addingNewSession){//clicked add new
		return (
			<>
				<p>Before we can open a new session you have to close the following open session for this weigher:</p>
				<div style = {{textAlign: 'center', fontWeight: 'bold'}}>
				<OpenSessionList openSessions = { props.openSessions } />
				</div>
				< hr />
				{ postMsg }
				<br />
			</>
		)
	} else {//clicked session close
		return (
			<>
				<p>You are about to close the session:</p>
				<div style = {{textAlign: 'center', fontWeight: 'bold'}}>
				<OpenSessionList openSessions = { props.openSessions } />
				</div>
				< hr />
				{ postMsg }
				<br />
			</>
		)
	}
}


const OpenSessionList = (props) =>{
	if (props.openSessions !== undefined && props.openSessions.length > 0){
		return (
			<>
			{props.openSessions.map((row, idx) => (
				<p key = {idx}>{ row.SessionName } [{ row.SessionID }]</p>
			))}
			</>
		)
	} else {
		return (<p>There are NO sessions currently open for this weigher.</p>)
	}
}

const Template = (props) =>{
	const handleClose = () => props.setSessionChangeModalShow(false);
	return (
		<Modal
			// { ...props }
			show = { props.sessionChangeModalShow }
			onHide = { handleClose }
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
		<Modal.Header closeButton>
			<Modal.Title id="contained-modal-title-vcenter">
				{ props.header }
			</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			{/* <h4>{ props.title }</h4> */}
			{ props.children }
			<div style={{height:'5em'}} />{/* work around as controls overlap footer */}
		</Modal.Body>
		<Modal.Footer>
			{ props.footer }
		</Modal.Footer>
	</Modal>
	)
}

export default SessionChangeModal